class EmploymentFeed extends HTMLElement {
    connectedCallback() {
        this.fetchJobs();
    }

    async fetchJobs() {
            const url = "https://api.employmenthero.com/ats/api/v1/embedded/organisations/4d9beee1-7d01-42bd-b70f-1a1cf57b150e/jobs";
            const token = "gcM5GaE0Y1trwrKKrj1oZw";

            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'X_ATS_TOKEN': token,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const ProvidedData = await response.json();

                if (ProvidedData.data.total_items > 1) {
                    this.querySelector('.no-position-available').style.display = 'none';
                }

                const items = ProvidedData.data.items;
                const htmlContent = items.map((job, index) => `
                <div class="job-tab" data-carouselable data-aos-once="true" data-aos="fade-in" data-aos-delay="${index + 3}00">
                    <div class="tab-header" id="header-${index}" onclick="toggleDetails(${index}, event)">
                        <div class="tab-header-content">
                            <img src="${job.recruitment_logo}" alt="Company Logo" class="job-logo">
                            <div>
                                <h3>${job.title}</h3>
                                <p><strong>Department:</strong> ${job.department}</p>
                                <p><strong>Location:</strong> ${job.city}, ${job.country_name}</p>
                            </div>
                        </div>
                        <a href="${job.application_url}" target="_blank">Apply Now</a>
                    </div>
                    <div class="tab-content" id="details-${index}" onclick="toggleDetails(${index}, event)">
                        ${!job.hide_pay_rate ? `<p><strong>Salary:</strong> ${job.salary_min} - ${job.salary_max} ${job.salary_currency} per ${job.salary_rate_name}</p>` : ''}
                        <p><strong>Employment Type:</strong> ${job.employment_type_name}</p>
                        <p><strong>Employment Term:</strong> ${job.employment_term_name}</p>
                        <p><strong>Experience Level:</strong> ${job.experience_level_name}</p>
                        <div class="job-description">${job.description}</div>
                        <a href="${job.application_url}" target="_blank">Apply Now</a>
                    </div>
                </div>
            `).join('');

            this.querySelector('#employmenthero').innerHTML = htmlContent;
        } catch (error) {
            console.error('Error:', error);
        }
    }
}

customElements.define('employment-feed', EmploymentFeed);

function toggleDetails(index, event) {
    const details = document.getElementById(`details-${index}`);
    const header = document.getElementById(`header-${index}`);
    const jobTab = header.closest('.job-tab');
    const isOpen = details.style.display === 'block';
    
    document.querySelectorAll('.tab-content').forEach(content => {
        content.style.display = 'none';
    });

    if (!isOpen) {
        details.style.display = 'block';
    }

    jobTab.scrollIntoView({ behavior: 'smooth', block: 'center' });
    
    event.stopPropagation();
}